import React from 'react'
import { Helmet } from 'react-helmet'
import { generateMetaTags } from '@/helpers/generateMetaTags'
import { SEOProps } from './types'

export const SEO: React.FC<SEOProps> = (props) => {
  const { lang, seo_title, schema_markup } = props
  const metaTags = generateMetaTags(props)

  const additionalHelmetParams: any = {}
  if (metaTags.links.length) {
    additionalHelmetParams.link = metaTags.links
  }

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      defaultTitle="Beebole"
      {...additionalHelmetParams}
    >
      <title data-react-helmet="true">{seo_title}</title>
      {!!metaTags.meta && metaTags.meta.map((metaTag, index) => <meta key={`${metaTag.key}-${index}`} {...metaTag} />)}
      {schema_markup && <script type="application/ld+json">{schema_markup}</script>}
    </Helmet>
  )
}
